import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "parameter-expand" }

import { ref } from "vue";
import BaseModal from "@/components/common/modal/BaseModal.vue";
import ParameterInline from "@/components/multiedit/temporary/ParameterInline.vue";
import { ParameterInstanceContainer } from "@/models/interfaces/parameters/parameter-models";

type ParameterExpandModalProps = {
	id: string,
	title: string,
	modelValue: ParameterInstanceContainer[],
	editable?: boolean,
	tokenStyles?: Record<string, string>,
	showFieldLabel?: boolean,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ParameterExpandModal',
  props: {
    id: {},
    title: {},
    modelValue: {},
    editable: { type: Boolean, default: false },
    tokenStyles: {},
    showFieldLabel: { type: Boolean, default: true }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

const $modal = ref<InstanceType<typeof BaseModal> | null>(null)
// Таблица нужна параметру как якорь контекстного меню, поэтому он рендерится вторым проходом
const $table = ref<HTMLElement | null>(null)

const onOpen = () => $modal.value?.onOpen()
const onClose = () => $modal.value?.onClose()

__expose({ onOpen, onClose })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    ref_key: "$modal",
    ref: $modal,
    title: props.title,
    width: "max-content",
    "max-width": "90vw",
    height: "max-content"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("table", {
          class: "dialog-table",
          ref_key: "$table",
          ref: $table
        }, [
          ($table.value)
            ? (_openBlock(), _createBlock(ParameterInline, {
                key: 0,
                "is-root": "",
                "is-table": "",
                editable: props.editable,
                id: props.id,
                "model-value": props.modelValue,
                "token-styles": props.tokenStyles,
                "show-custom": false,
                "value-set-from-instance": true,
                "context-trigger": $table.value,
                "create-mode": false,
                "show-field-label": props.showFieldLabel,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => emit('update:modelValue', value))
              }, null, 8, ["editable", "id", "model-value", "token-styles", "context-trigger", "show-field-label"]))
            : _createCommentVNode("", true)
        ], 512)
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})